import { getPath } from '@/router/common'

const baseUrl = {
  title: '价格体系',
  path: 'priceSystem'
}

export default [
  {
    path: getPath('priceSystem', baseUrl),
    name: 'priceSystem',
    component: () => import('@/views/priceSystem/priceSystem.vue'),
    meta: {
      title: '发货人运价体系'
    }
  },
  {
    path: getPath('fahuoPrice', baseUrl),
    name: 'fahuoPrice',
    component: () => import('@/views/priceSystem/fahuoPrice/index.vue'),
    meta: {
      title: '发货人运价体系'
    }
  },
  {
    path: getPath('fahuoPriceAdd', baseUrl),
    name: 'FahuoPriceAdd',
    component: () =>
      import(
        /* webpackChunkName: "FahuoPriceAdd" */ '@/views/priceSystem/fahuoPriceAdd/index.vue'
      ),
    meta: {
      title: '新增/导入发货人价格'
    }
  },
  {
    path: getPath('EditPrice', baseUrl),
    name: 'EditPrice',
    component: () =>
      import(
        /* webpackChunkName: "EditPrice" */ '@/views/priceSystem/editPrice/index.vue'
      ),
    meta: {
      title: '修改价格'
    }
  },
  {
    path: getPath('index2', baseUrl),
    name: 'PriceSystemIndex2',
    component: () =>
      import(
        /* webpackChunkName: "Index2" */ '@/views/priceSystem/index2/index.vue'
      ),
    meta: {
      title: '送货费标准'
    }
  },
  {
    path: getPath('standardSettle', baseUrl),
    name: 'StandardSettle',
    component: () =>
      import(
        /* webpackChunkName: "standardSettle" */ '@/views/priceSystem/standardSettle/index.vue'
      ),
    meta: {
      title: '结算送货费标准'
    }
  },
  {
    path: getPath('commissionStandard', baseUrl),
    name: 'commissionStandard',
    component: () =>
      import(
        /* webpackChunkName: "commissionStandard" */ '@/views/priceSystem/commissionStandard/index.vue'
      ),
    meta: {
      title: '开单员提成标准'
    }
  },
  {
    path: getPath('safeIndex', baseUrl),
    name: 'safeIndex',
    component: () =>
      import(
        /* webpackChunkName: "safeIndex" */ '@/views/priceSystem/safeIndex/index.vue'
      ),
    meta: {
      title: '保险费标准'
    }
  },
  {
    path: getPath('add', baseUrl),
    name: 'PriceSystemAdd',
    component: () =>
      import(/* webpackChunkName: "add" */ '@/views/priceSystem/add/index.vue'),
    meta: {
      title: '新增/导入价格'
    }
  },
  {
    path: getPath('newStandardAdd', baseUrl),
    name: 'NewStandardAdd',
    component: () =>
      import(/* webpackChunkName: "newStandardAdd" */ '@/views/priceSystem/newStandardAdd/index.vue'),
    meta: {
      title: '新增/导入价格'
    }
  },
  {
    path: getPath('index', baseUrl),
    name: 'PriceSystemIndex',
    component: () => import('@/views/priceSystem/index/index.vue'),
    meta: {
      title: '运费价格标准'
    }
  },
  {
    path: getPath('EditPrice2', baseUrl),
    name: 'EditPrice2',
    component: () =>
      import(
        /* webpackChunkName: "EditPrice2" */ '@/views/priceSystem/editPrice2/index.vue'
      ),
    meta: {
      title: '运费价格标准修改'
    }
  },
  {
    path: getPath('fahuoPriceSystemAdd', baseUrl),
    name: 'FahuoPriceSystemAdd',
    component: () => import(/* webpackChunkName: "FahuoPriceSystemAdd" */ '@/views/priceSystem/fahuoPriceSystemAdd/index.vue'),
    meta: {
      title: '打开导入运单弹窗'
    }
  },
  {
    path: getPath('fahuoEditPrice', baseUrl),
    name: 'FahuoEditPrice',
    component: () => import(/* webpackChunkName: "FahuoEditPrice" */ '@/views/priceSystem/fahuoEditPrice/index.vue'),
    meta: {
      title: '新增编辑价格体系'
    }
  },
  {
    path: getPath('fahuoPrice88854', baseUrl),
    name: 'fahuoPrice88854',
    component: () => import(/* webpackChunkName: "fahuoPrice88854" */ '@/views/priceSystem/fahuoPrice88854/index.vue'),
    meta: {
      title: '发货人运价体系88854'
    }
  },
  {
    path: getPath('SuperLossPrice_80987', baseUrl),
    name: 'SuperLossPrice_80987',
    component: () => import(/* webpackChunkName: "SuperLossPrice_80987" */ '@/views/priceSystem/superLossPrice_80987/index.vue'),
    meta: {
      title: '超损耗配置'
    }
  },
  {
    path: getPath('RestrictionAreas', baseUrl),
    name: 'priceSystemRestrictionAreas',
    component: () => import(/* webpackChunkName: "priceSystemRestrictionAreas" */ '@/views/priceSystem/restrictionAreas/index.vue'),
    meta: {
      title: '开单受限地区设置'
    }
  },
  {
    path: getPath('intervalSetting', baseUrl),
    name: 'priceSystem_intervalSetting',
    component: () => import(/* webpackChunkName: "priceSystem_intervalSetting" */ '@/views/priceSystem/intervalSetting/index.vue'),
    meta: {
      title: '区间段设置'
    }
  },
  {
    path: getPath('intervalSettingAdd2', baseUrl),
    name: 'priceSystem_intervalSettingAdd2',
    component: () => import(/* webpackChunkName: "priceSystem_intervalSettingAdd2" */ '@/views/priceSystem/intervalSettingAdd2/index.vue'),
    meta: {
      title: '区间段设置新增'
    }
  },
  {
    path: getPath('TransitIndex', baseUrl),
    name: 'priceSystem_TransitIndex',
    component: () => import(/* webpackChunkName: "priceSystem_TransitIndex" */ '@/views/priceSystem/transitIndex/index.vue'),
    meta: {
      title: '中转费价格标准'
    }
  },
  {
    path: getPath('EditPriceZz', baseUrl),
    name: 'priceSystem_EditPriceZz',
    component: () => import(/* webpackChunkName: "priceSystem_EditPriceZz" */ '@/views/priceSystem/editPriceZz/index.vue'),
    meta: {
      title: '中转费价格标准修改'
    }
  },
  {
    path: getPath('LinePriceSearch', baseUrl),
    name: 'priceSystem_LinePriceSearch',
    component: () => import(/* webpackChunkName: "priceSystem_LinePriceSearch" */ '@/views/priceSystem/linePriceSearch/index.vue'),
    meta: {
      title: '线路价格标准'
    }
  },
  {
    path: getPath('AccsendoutPrice', baseUrl),
    name: 'priceSystem_AccsendoutPrice',
    component: () => import(/* webpackChunkName: "priceSystem_AccsendoutPrice" */ '@/views/priceSystem/accsendoutPrice/index.vue'),
    meta: {
      title: '实际送货费价格标准'
    }
  },
  {
    path: getPath('SalesmanSetting', baseUrl),
    name: 'priceSystem_SalesmanSetting',
    component: () => import(/* webpackChunkName: "priceSystem_SalesmanSetting" */ '@/views/priceSystem/salesmanSetting/index.vue'),
    meta: {
      title: '业务员提成标准'
    }
  },
  {
    path: getPath('priceSystemEdit_87569', baseUrl),
    name: 'priceSystem_priceSystemEdit_87569',
    component: () => import(/* webpackChunkName: "priceSystem_priceSystemEdit_87569" */ '@/views/priceSystem/priceSystemEdit_87569/index.vue'),
    meta: {
      title: '修改业务员提成标准'
    }
  },
  {
    path: getPath('priceSystemAdd_87569', baseUrl),
    name: 'priceSystem_priceSystemAdd_87569',
    component: () => import(/* webpackChunkName: "priceSystem_priceSystemAdd_87569" */ '@/views/priceSystem/priceSystemAdd_87569/index.vue'),
    meta: {
      title: '导入业务员提成标准'
    }
  },
  {
    path: getPath('UnloadingSetting', baseUrl),
    name: 'priceSystem_UnloadingSetting',
    component: () => import(/* webpackChunkName: "priceSystem_UnloadingSetting" */ '@/views/priceSystem/unloadingSetting/index.vue'),
    meta: {
      title: '卸货费标准'
    }
  },
  {
    path: getPath('DivideIntoSetting', baseUrl),
    name: 'priceSystem_DivideIntoSetting',
    component: () => import(/* webpackChunkName: "priceSystem_DivideIntoSetting" */ '@/views/priceSystem/divideIntoSetting/index.vue'),
    meta: {
      title: '分成比例标准'
    }
  },
  {
    path: getPath('DivieIntoaddImport', baseUrl),
    name: 'priceSystem_DivieIntoaddImport',
    component: () => import(/* webpackChunkName: "priceSystem_DivieIntoaddImport" */ '@/views/priceSystem/divieIntoaddImport/index.vue'),
    meta: {
      title: '新增导入分成比例标准'
    }
  },
  {
    path: getPath('AddDivideIntoSetting', baseUrl),
    name: 'priceSystem_AddDivideIntoSetting',
    component: () => import(/* webpackChunkName: "priceSystem_AddDivideIntoSetting" */ '@/views/priceSystem/addDivideIntoSetting/index.vue'),
    meta: {
      title: '分成比例标准修改'
    }
  },
  {
    path: getPath('PriceSystem82337', baseUrl),
    name: 'priceSystem_PriceSystem82337',
    component: () => import(/* webpackChunkName: "priceSystem_PriceSystem82337" */ '@/views/priceSystem/priceSystem82337/index.vue'),
    meta: {
      title: '运费价格标准'
    }
  },
  {
    path: getPath('customerprice', baseUrl),
    name: 'priceSystem_customerprice',
    component: () => import(/* webpackChunkName: "priceSystem_customerprice" */ '@/views/priceSystem/customerprice/index.vue'),
    meta: {
      title: '客户报价'
    }
  },
  {
    path: getPath('customerPriceEdit', baseUrl),
    name: 'priceSystem_customerPriceEdit',
    component: () => import(/* webpackChunkName: "priceSystem_customerPriceEdit" */ '@/views/priceSystem/customerPriceEdit/index.vue'),
    meta: {
      title: '修改客户报价'
    }
  },
  {
    path: getPath('Customerpriceadd', baseUrl),
    name: 'priceSystem_Customerpriceadd',
    component: () => import(/* webpackChunkName: "priceSystem_Customerpriceadd" */ '@/views/priceSystem/customerpriceadd/index.vue'),
    meta: {
      title: '新增客户报价'
    }
  },
  {
    path: getPath('outaccprice', baseUrl),
    name: 'priceSystem_outaccprice',
    component: () => import(/* webpackChunkName: "priceSystem_outaccprice" */ '@/views/priceSystem/outaccprice/index.vue'),
    meta: {
      title: '代理报价'
    }
  },
  {
    path: getPath('outaccpriceadd', baseUrl),
    name: 'priceSystem_outaccpriceadd',
    component: () => import(/* webpackChunkName: "priceSystem_outaccpriceadd" */ '@/views/priceSystem/outaccpriceadd/index.vue'),
    meta: {
      title: '新增/导入代理报价'
    }
  },
  {
    path: getPath('OutAccPriceEdit', baseUrl),
    name: 'priceSystem_OutAccPriceEdit',
    component: () => import(/* webpackChunkName: "priceSystem_OutAccPriceEdit" */ '@/views/priceSystem/outAccPriceEdit/index.vue'),
    meta: {
      title: '修改代理报价'
    }
  },
  {
    path: getPath('zcPriceEdit', baseUrl),
    name: 'priceSystem_zcPriceEdit',
    component: () => import(/* webpackChunkName: "priceSystem_zcPriceEdit" */ '@/views/priceSystem/zcPriceEdit/index.vue'),
    meta: {
      title: '修改整车报价'
    }
  },
  {
    path: getPath('zcprice', baseUrl),
    name: 'priceSystem_zcprice',
    component: () => import(/* webpackChunkName: "priceSystem_zcprice" */ '@/views/priceSystem/zcprice/index.vue'),
    meta: {
      title: '整车报价'
    }
  },
  {
    path: getPath('zcpriceadd', baseUrl),
    name: 'priceSystem_zcpriceadd',
    component: () => import(/* webpackChunkName: "priceSystem_zcpriceadd" */ '@/views/priceSystem/zcpriceadd/index.vue'),
    meta: {
      title: '新增/导入整车报价'
    }
  },
  {
    path: getPath('outaccprice_shka', baseUrl),
    name: 'priceSystem_outaccprice_shka',
    component: () => import(/* webpackChunkName: "priceSystem_outaccprice_shka" */ '@/views/priceSystem/outaccprice_shka/index.vue'),
    meta: {
      title: '上海KA报价'
    }
  },
  {
    path: getPath('outaccpriceadd_shka', baseUrl),
    name: 'priceSystem_outaccpriceadd_shka',
    component: () => import(/* webpackChunkName: "priceSystem_outaccpriceadd_shka" */ '@/views/priceSystem/outaccpriceadd_shka/index.vue'),
    meta: {
      title: '新增/导入价格'
    }
  },
  {
    path: getPath('OutAccPriceEdit_shka', baseUrl),
    name: 'priceSystem_OutAccPriceEdit_shka',
    component: () => import(/* webpackChunkName: "priceSystem_OutAccPriceEdit_shka" */ '@/views/priceSystem/outAccPriceEdit_shka/index.vue'),
    meta: {
      title: '修改代理报价'
    }
  },
  {
    path: getPath('tsprice', baseUrl),
    name: 'priceSystem_tsprice',
    component: () => import(/* webpackChunkName: "priceSystem_tsprice" */ '@/views/priceSystem/tsprice/index.vue'),
    meta: {
      title: '特殊报价'
    }
  },
  {
    path: getPath('AddEdittsprice', baseUrl),
    name: 'priceSystem_AddEdittsprice',
    component: () => import(/* webpackChunkName: "priceSystem_AddEdittsprice" */ '@/views/priceSystem/addEdittsprice/index.vue'),
    meta: {
      title: '特殊报价新增'
    }
  },
  {
    path: getPath('Index_80799', baseUrl),
    name: 'priceSystem_Index_80799',
    component: () => import(/* webpackChunkName: "priceSystem_Index_80799" */ '@/views/priceSystem/index_80799/index.vue'),
    meta: {
      title: '运费价格标准'
    }
  },
  {
    path: getPath('Index_81930', baseUrl),
    name: 'priceSystem_Index_81930',
    component: () => import(/* webpackChunkName: "priceSystem_Index_81930" */ '@/views/priceSystem/index_81930/index.vue'),
    meta: {
      title: '运费价格标准'
    }
  },
  {
    path: getPath('Index_96209', baseUrl),
    name: 'priceSystem_Index_96209',
    component: () => import(/* webpackChunkName: "priceSystem_Index_96209" */ '@/views/priceSystem/index_96209/index.vue'),
    meta: {
      title: '运费价格标准'
    }
  },
  {
    path: getPath('outaccStandard', baseUrl),
    name: 'priceSystem_outaccStandard',
    component: () => import(/* webpackChunkName: "priceSystem_outaccStandard" */ '@/views/priceSystem/outaccStandard/index.vue'),
    meta: {
      title: '结算中转费标准'
    }
  },
  {
    path: getPath('ImportPriceSystemEx', baseUrl),
    name: 'priceSystem_ImportPriceSystemEx',
    component: () => import(/* webpackChunkName: "priceSystem_ImportPriceSystemEx" */ '@/views/priceSystem/importPriceSystemEx/index.vue'),
    meta: {
      title: '新增导入中转费标准'
    }
  },
  {
    path: getPath('EditPriceSystemEx', baseUrl),
    name: 'priceSystem_EditPriceSystemEx',
    component: () => import(/* webpackChunkName: "priceSystem_EditPriceSystemEx" */ '@/views/priceSystem/editPriceSystemEx/index.vue'),
    meta: {
      title: '修改导入中转费标准'
    }
  },
  {
    path: getPath('JincangIndex79710', baseUrl),
    name: 'priceSystem_JincangIndex79710',
    component: () => import(/* webpackChunkName: "priceSystem_JincangIndex79710" */ '@/views/priceSystem/jincangIndex79710/index.vue'),
    meta: {
      title: '进仓费收入标准'
    }
  },
  {
    path: getPath('ProductName79710', baseUrl),
    name: 'priceSystem_ProductName79710',
    component: () => import(/* webpackChunkName: "priceSystem_ProductName79710" */ '@/views/priceSystem/productName79710/index.vue'),
    meta: {
      title: '品名资料'
    }
  },
  {
    path: getPath('addOrEditProductName', baseUrl),
    name: 'priceSystem_addOrEditProductName',
    component: () => import(/* webpackChunkName: "priceSystem_addOrEditProductName" */ '@/views/priceSystem/addOrEditProductName/index.vue'),
    meta: {
      title: '新增品名资料'
    }
  },
  {
    path: getPath('AcctransStandard', baseUrl),
    name: 'priceSystem_AcctransStandard',
    component: () => import(/* webpackChunkName: "priceSystem_AcctransStandard" */ '@/views/priceSystem/acctransStandard/index.vue'),
    meta: {
      title: '基本运费价格体系'
    }
  },
  {
    path: getPath('Standard_weight_95066', baseUrl),
    name: 'PriceSystem_standard_weight_95066',
    component: () => import(/* webpackChunkName: "priceSystem_standard_weight_95066" */ '@/views/priceSystem/standard_weight_95066/index.vue'),
    meta: {
      title: '重泡比设置' // 重泡比设置 // 自提运费价格标准 // 送货运费价格标准 // 结算送货费标准 // 结算中转费标准
    }
  },
  {
    path: getPath('Standard_weight_addEdit_95066', baseUrl),
    name: 'PriceSystem_standard_weight_addEdit_95066',
    component: () => import(/* webpackChunkName: "priceSystem_standard_weight_95066" */ '@/views/priceSystem/standard_weight_95066/addEdit.vue'),
    meta: {
      title: '重泡比新增' // 重泡比设置 // 自提运费价格标准 // 送货运费价格标准 // 结算送货费标准 // 结算中转费标准 新增修改页面
    }
  },
  {
    path: getPath('gyprice', baseUrl),
    name: 'PriceSystem_gyprice',
    component: () => import(/* webpackChunkName: "priceSystem_gyprice" */ '@/views/priceSystem/gyprice/index.vue'),
    meta: {
      title: '钢运物流价格标准' // 钢运物流价格体系
    }
  }
]
